export default {
  CARD: {
    TITLE: `Shift Offers`,
    SUMMARY: ``
  },
  PRIORITY_DELAY: `Remaining priority delay: {{ until }}`,
  REFUSE_ALL_SHIFT_OFFERS: `Refuse all`,
  ALL_SHIFT_OFFERS_REFUSED: `All shift offers have been refused`,
  NO_OFFERS: `You currently have no shift offers`,
  SHIFT_ACCEPTED: `Accepted`,
  SHIFT_REFUSED: `Refused`,
  SHIFT_NOT_AVAILABLE_DESCRIPTION: `This shift is no longer available.`,
  ARRIVALTIME: {
    LABEL: `Around what time do you think you'll be able to arrive?`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  ARRIVAL_TIME_REQUIRED: `You cannot submit an empty arrival time`,
  ALREADY_ACCEPTED_SHIFT: `You are no longer eligible for this shift`
}
